export default __webpack_public_path__ + "static/media/3.e1ff261f.png";